// extracted by mini-css-extract-plugin
module.exports = {"siteLogo":"logo-module--siteLogo--3GqL-"};